import React, { useEffect, useState } from "react";
import api from "../services/api";

const STATUS_LABELS = { validated: "Validé", rejected: "Refusé", pending: "En attente" };
const STATUS_CLASS = { validated: "success", rejected: "danger", pending: "warning" };

function formatDays(days) {
  const value = Number(days);
  if (!Number.isFinite(value) || value <= 0) return "0 jour";
  const rounded = Math.round(value * 100) / 100;
  return `${rounded} jour${rounded > 1 ? "s" : ""}`;
}

export default function AdminReferralSpace() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("referrals/admin/referrals/").then(r => setItems(r.data)).catch(() => setError("Impossible de charger les parrainages."));
  }, []);

  if (error) return <div className="ap-page"><h1>Parrainage</h1><div className="alert alert-warning">{error}</div></div>;
  if (!items) return <div className="ap-page"><h1>Parrainage</h1><p className="text-muted">Chargement…</p></div>;

  return <div className="ap-page">
    <h1>Parrainage</h1>
    <p className="ap-page-desc">Dès qu’un filleul paie son abonnement, 10% du nombre de jours souscrits est automatiquement ajouté à l’abonnement de son parrain. Rien à valider — cette page ne sert qu’à suivre les parrainages.</p>
    {items.length === 0 ? <p>Aucun parrainage enregistré.</p> : (
      <div className="pt-directory">
        {items.map(item => (
          <article key={item.id} className="pt-teacher-card ap-referral-card">
            <div className="pt-avatar"><i className="bi bi-people-fill"></i></div>
            <div>
              <span className={`ap-teacher-card-status badge bg-${STATUS_CLASS[item.status] || "secondary"}`}>{STATUS_LABELS[item.status] || item.status}</span>
              <h3>{item.referrer_name}</h3>
              <p><i className="bi bi-arrow-right"></i> a parrainé {item.referred_name}</p>
              <p className="text-muted small">{item.campaign}</p>
              <div className="ap-referral-days">
                <i className="bi bi-gift"></i> {formatDays(item.days_awarded)} ajouté{Number(item.days_awarded) > 1 ? "s" : ""} au parrain
              </div>
            </div>
          </article>
        ))}
      </div>
    )}
  </div>;
}
